/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-12 14:26:48
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-07 12:45:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/tools.ts
 */
import _ from 'lodash';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
import {
  contentSettingValidation,
  buttonTextValidation,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/validation';
import { defaultCollapse } from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/common';
import { EnumCollapseId } from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/common';

const convertDataFromServerToRedux = (data, isPrimary?) => {
  const {
    contentUuid,
    buttonStyle = {},
    contentSetting = {},
    featuredProducts = {},
    uuid,
    salesChannelContent,
    salesChannelName,
    storeUuid,
    hasError,
  } = data || {};
  const isNew = !uuid;
  const { collapseOpen, collapseErrorMsgDisplay } = defaultCollapse(!isNew);

  if (!isNew && hasError) {
    let flag = false;

    const { hasError: contentSettingHasError } = contentSettingValidation(
      contentSetting,
      isPrimary,
    );
    if (contentSettingHasError) {
      collapseErrorMsgDisplay[EnumCollapseId.contentSetting].hasError = true;
      collapseErrorMsgDisplay[EnumCollapseId.contentSetting].display = true;
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.contentSetting] = true;
      }
    }
    ///================================
    const { hasError: btnHasError } = buttonTextValidation(
      buttonStyle,
      isPrimary,
    );
    if (btnHasError) {
      collapseErrorMsgDisplay[EnumCollapseId.buttonText].hasError = true;
      collapseErrorMsgDisplay[EnumCollapseId.buttonText].display = true;
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.buttonText] = true;
      }
    }
  }

  return {
    contentUuid,
    storeUuid,
    uuid,
    featureProduct: {
      isValid: featuredProducts.enabled,
      title: featuredProducts.title,
      dataSet: featuredProducts.products,
      titleTextColor: featuredProducts.titleTextColor,
    },
    buttonText: {
      text: _.get(buttonStyle, 'text', ''),
      buttonThemeUuid: _.get(buttonStyle, 'buttonThemeUuid', ''),
    },
    salesChannelContent,
    salesChannelName,
    contentSetting: {
      text: _.get(contentSetting, 'title', ''),
      image: _.get(contentSetting, 'image', null),
    },
    collapseOpen,
    collapseErrorMsgDisplay,
    ...reduxUpdatedStatusControl,
  };
};

const convertDataFromReduxToServer = (state) => {
  const setting = _.cloneDeep(state);
  const {
    buttonText,
    contentSetting,
    contentUuid,
    storeUuid,
    uuid,
    featureProduct,
  } = setting;
  return {
    uuid,
    storeUuid,
    contentUuid,
    contentSetting: {
      title: contentSetting.text,
      image: contentSetting.image,
    },
    buttonStyle: {
      text: buttonText.text,
      buttonThemeUuid: buttonText.buttonThemeUuid,
    },
    featuredProducts: featureProduct,
  };
};

export { convertDataFromReduxToServer, convertDataFromServerToRedux };
